import { localDateToSeconds } from '@/platform/lib/utils';
import {
    Badge,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import InfoTip from './InfoTip';

// Routine steps (each item, the login on its way) are plain text so the
// notable ones stand out: logged in, completed, softblock and errors.
const isNotable = step => step.step_color !== 'gray';

const TrailTable = ({ steps, emptyText }) => {
    const hasDetail = steps?.some(step => step.detail);
    const columns = hasDetail ? 4 : 3;

    return (
        <Table striped>
            <TableHeader>
                <TableRow>
                    <TableHeaderCell>Tijd</TableHeaderCell>
                    <TableHeaderCell textAlign='right'>
                        Controle in batch
                        <InfoTip label='Uitleg over controle in batch'>
                            Het volgnummer van de controle binnen de batch, in
                            plaats van een BSN.
                        </InfoTip>
                    </TableHeaderCell>
                    <TableHeaderCell>Stap</TableHeaderCell>
                    {hasDetail && (
                        <TableHeaderCell>Toelichting</TableHeaderCell>
                    )}
                </TableRow>
            </TableHeader>
            <TableBody>
                {(!steps || steps.length === 0) && (
                    <TableRow>
                        <TableCell
                            colSpan={columns}
                            textAlign='center'
                            className='py-6 text-sm text-gray-500'
                        >
                            {emptyText}
                        </TableCell>
                    </TableRow>
                )}

                {steps?.map(step => (
                    <TableRow key={step.id}>
                        {/* Seconds matter: a login can sit on the SMS step for two minutes. */}
                        <TableCell singleLine>
                            {localDateToSeconds(step.created_at)}
                        </TableCell>
                        <TableCell textAlign='right' className='tabular-nums'>
                            {step.item ?? ''}
                        </TableCell>
                        <TableCell singleLine>
                            {isNotable(step) ? (
                                <Badge color={step.step_color}>
                                    {step.step_label}
                                </Badge>
                            ) : (
                                <span className='text-sm text-gray-700'>
                                    {step.step_label}
                                </span>
                            )}
                        </TableCell>
                        {hasDetail && (
                            <TableCell className='text-sm text-gray-500'>
                                {step.detail}
                            </TableCell>
                        )}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default TrailTable;
